import axiosInstance from "../api";
import { notification } from "antd";


export const getAllUserVisit = async ({
  skip = 0,
  limit = 10,
  user_id = null,
  start_date = null,
  end_date = null,
  visit_type = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (user_id) params.append("user_id", user_id);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (visit_type) params.append("visit_type", visit_type);
    

    const response = await axiosInstance.get(
      `/user_metrics/admin_get_user_vist?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching User Metrics",
      description:
        response?.data?.message || "Failed to fetch User Metrics Visit.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching User Metrics Visit.",
      description:
        error.response?.data?.message || "Failed to fetch User Metrics Visit..",
      duration: 3,
    });
    throw new Error("Error fetching User Metrics Visit.");
  }
};

export const getAllUserActionByVisitID = async (visit_id) => {
  try {
    console.log(visit_id, 'visit-d')
    const params = new URLSearchParams();
    params.append("visit_id", visit_id);

    const response = await axiosInstance.get(
      `/user_metrics/admin_get_user_action?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching User Metrics Action",
      description:
        response?.data?.message || "Failed to fetch User Metrics Action.",
      duration: 3,
    });
  }
  catch (error) {
    notification.error({
      message: "Error Fetching User Metrics Action.",
      description:
        error.response?.data?.message || "Failed to fetch User Metrics Action..",
      duration: 3,
    });
    throw new Error("Error fetching User Metrics Action.");
  }
};


export const downloadUserMetrics = async ({
  user_id=null, 
  start_date=null, 
  end_date=null,
  visit_type=null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (user_id) params.append("user_id", user_id);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (visit_type) params.append("visit_type", visit_type);

    const response = await axiosInstance.get(`/user_metrics/admin_export_user_visit_action?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "user_metrics.xlsx"; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      return response; 
    } else {
      throw new Error("Download failed"); 
    }
  } catch (error) {
    console.error("Error downloading user Metrics:", error);
    notification.error({
      message: "Error Downloading Users",
      description: error.response?.data?.message || "Failed to download user metrics.",
      duration: 3,
    });
    throw error; 
  }
};